export default Object.freeze({
  STUDENT: 'student',
  ADULT: 'adult'
})



// WEBPACK FOOTER //
// ./src/constants/registration/planTypes.js